addEventListener("DOMContentLoaded", () => {
  const userAgent = navigator.userAgent
  
  const setUserAgentInfo = () => {
    const cartDrawerUserNote = document.getElementById('cart-drawer-user-note')
    if (cartDrawerUserNote) {
      cartDrawerUserNote.value = userAgent
      cartDrawerUserNote.innerText = userAgent
    }
  }
  
  setUserAgentInfo()
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.id === 'cart-drawer-user-note' || node.querySelector('#cart-drawer-user-note')) {
              setUserAgentInfo()
            }
          }
        })
      }
    })
  })
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
})